import { privateInstance } from "../configs";

export const inventoryTemplateApi = {
  async getInventoryTemplates(params) {
    let url = "/recipes/api/inventory/template/list/";

    if (params) {
      if (params.store) url += `?store=${params.store}/`;
    }

    const res = await privateInstance.get(url);
    return res.data;
  },
  async postInventoryTemplate(template) {
    const res = await privateInstance.post(
      "/recipes/api/inventory/template/list/",
      template
    );
    return res.data;
  },
  async retrieveInventoryTemplate(id) {
    const res = await privateInstance.get(
      `/recipes/api/inventory/template/${id}/`
    );
    return res.data;
  },
  async putInventoryTemplate(id, template) {
    const res = await privateInstance.put(
      `/recipes/api/inventory/template/${id}/`,
      template
    );
    return res.data;
  },
  async deleteInventoryTemplate(id) {
    const res = await privateInstance.delete(
      `/recipes/api/inventory/template/${id}/`
    );
    return res.data;
  },
  async setDefaultInventoryTemplate(id) {
    const res = await privateInstance.post(
      `/recipes/api/inventory/template/default/${id}/`
    );
    return res.data;
  }
};
